import { useContext } from 'react'
import { ImperialBookingContext } from '../context/ImperialBookingContext'
import { isUndefined } from 'lodash-es'
import { Auth, Hub } from 'aws-amplify'

const useApiRequest = () => {
  const { getCredentials } = useContext(ImperialBookingContext)

  const apiGet = async (resource, options = {}) => {
    try {
      const { userId, accessToken } = await getCredentials()

      const headers = new Headers({
        'Content-Type': 'application/json',
        //'X-Requested-With': 'imperial-bookings',
        'X-User-Id': userId,
        'Authorization': accessToken,
      })

      const promise = new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_BASE}/${resource}`, {
          headers,
          //mode: 'no-cors',
          //credentials: 'include',
          ...options,
        }).then((response) => {
          if (response.ok) {
            return response.json()
          } else {
            console.log(response)
            reject('Server error. Please report to support@theimperialstrata.com.')
            throw new Error('Failed response')
          }
        }).then((response) => {
          if (response.success) {
            resolve(response.payload)
          } else {
            if (isUndefined(response.success)) {
              reject('Server response lacking correct structure.')
            } else {
              reject(response.message)
            }
          }
        }).catch((err) => {
          console.log('Failing hard.')
        })
      })

      return promise
    } catch (e) {
      if (typeof e === "string" && /not authenticated/.test(e)) {
        Hub.dispatch('custom', { event: 'expiredAuth' }, 'useApiRequest.js')
      }
    }
  }

  const apiPost = (resource, payload) => {
    return apiGet(resource, { method: 'POST', body: JSON.stringify(payload) })
  }

  const apiPut = (resource, payload) => {
    return apiGet(resource, { method: 'PUT', body: JSON.stringify(payload) })
  }

  return {
    apiGet,
    apiPost,
    apiPut,
  }
}

export default useApiRequest
